/**
 * @description Returns a cookie value by name.
 * @param {String} name
 * @returns {String|Null}
 */
export const getCookie = (name) => {
  const pattern = RegExp(`${name}=.[^;]*`);
  const matched = document.cookie.match(pattern);
  if (matched) {
    const cookie = matched[0].split('=');
    return cookie[1];
  }
  return null;
};

/**
 * @description Sets the cookie value by name and expiration date.
 * @param {String} name
 * @param {String|Number} value
 * @param {Number} days
 */
export const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = date.toUTCString();
  document.cookie = `${name}=${value};expires=${expires};path=/`;
};

export default {
  getCookie,
  setCookie,
};
